import {Fragment, useContext, useEffect, useState} from "react";
import {MobileContext} from "../context/MobileContext";

const Sidebar = ({children, sidebarContent}) => {

    const [open, setOpen] = useState(true);

    const {isMobile} = useContext(MobileContext);

    useEffect(() => {
        if (isMobile === true) {
            setOpen(true)
        }
    }, [isMobile]);

    return (
        <Fragment>
            {
                !isMobile && !open &&
                <div className={"ns-sidebar-div"}>
                    <i className="fas fa-angle-double-right ns-mouse-pointer" onClick={() => {
                        setOpen(!open)
                    }} />
                </div>
            }
            <div className="row">
                <div className={open ? "col-md-3" : "d-none"}>
                    <div className={"ns-sidebar-col"}>
                        {
                            !isMobile && open &&
                            <div className={"w-100 text-end"}>
                            <div className={"ns-sidebar-div ps-2 pe-3"}>
                                <i className="fas fa-angle-double-left ns-mouse-pointer" onClick={() => {
                                    setOpen(!open)
                                }} />
                            </div>
                            </div>
                        }
                        {
                            sidebarContent()
                        }
                    </div>
                </div>
                <div className={open ? "col-md-9" : "col-md-12"}>
                    {children}
                </div>
            </div>
        </Fragment>
    )
}

export default Sidebar;